import { Topic } from "@masterschool/course-builder-api"
import { Box } from "@mui/material"
import { useEditEmptyLesson } from "../custom-hooks/useEditElementItem"
import { useSelectedEmptyLesson } from "../custom-hooks/useSelectedElementItem"
import EditLessonType from "./EditLessonType"
import { useAppSelector } from "@app/hooks"
import { MultiLanguageTitleTextField } from "../../components/multiLanguageFields/multiLanguageTitleTextField"

function EmptyLessonEditor(props: { topic: Topic }) {
  const { topic } = props
  const lesson = useSelectedEmptyLesson()
  const editLesson = useEditEmptyLesson()
  const editingLanguage = useAppSelector(
    (state) => state.courseEditor.editingLanguage,
  )

  if (!lesson) {
    return undefined
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
        gap: "24px",
        padding: "24px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          alignItems: "center",
          gap: "24px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            gap: "16px",
          }}
        >
          <MultiLanguageTitleTextField
            elementId={lesson.id}
            language={editingLanguage}
            defaultLanguageValue={lesson.title}
            extraLanguageValueRecord={lesson.extraLanguageTitleRecord}
            debounce
            onChangeDefaultLanguage={(value) => {
              editLesson(lesson, "title", value, topic)
            }}
            onChangeExtraLanguage={(value) => {
              editLesson(lesson, "extraLanguageTitleRecord", value, topic)
            }}
          />
          <EditLessonType topic={topic} />
        </Box>
      </Box>
    </Box>
  )
}

export default EmptyLessonEditor
